import React from 'react';
import {Card, CardContent} from "@mui/material";
import UserList from "./UserList";

export const ROLE_ADMIN = "admin";
export const ROLE_USER = "user";

export const roles = [ROLE_ADMIN, ROLE_USER]


function BrandUsers(props) {
  return (
    <>
      <div style={{ width: '100%' }}>
        <Card>
          <CardContent>
            {/*<PendingUserTable/>*/}
            {/*<ExistingUserTable/>*/}
            <UserList/>
          </CardContent>
        </Card>
      </div>
    </>
  );
}

export default BrandUsers;
